<div class="offcanvas offcanvas-start" tabindex="-1" id="groups" aria-labelledby="groups_label">
  <div class="offcanvas-body mt-3">
    <div class="d-flex justify-content-between mt-5">
      <div class="d-flex align-items-center mt-3">
       <h5 class="offcanvas-title d-flex align-items-center gap-2 mb-0" id="groups_label">
      {{ school_domain ? 'Classes' : 'Groups' }}</h5>
       <button
        class="btn btn-sm btn-primary fab d-flex justify-content-center align-items-center shadow-sm ms-3"
        @click="openCreateGroupModal"
        title="Create New"
        v-if="(school_domain && user_details.user_role === 'admin') || !school_domain"
      >
        <i class="bx bx-plus fw-bold"></i>
      </button>
      </div>

      <button
        type="button"
        class="btn-close text-reset me-2"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <table v-if="groups" class="table mb-0">
      <tbody>
        <tr v-for="group in groups" :key="group.id" class="border-0">
            <td class="border-0 align-middle px-2 py-2">
              <div class="d-flex justify-content-between align-items-center w-100">
                <div class="cursor-pointer d-flex align-items-center flex-grow-1 overflow-hidden" @click="open_group(group)">
                  <div class="portal-avatar bg-yellow d-flex justify-content-center align-items-center shadow-sm me-3">
                    <i :class="school_domain ? 'bx bxs-graduation fs-5 text-change' : 'bx bxs-group fs-5 text-change'"></i>
                  </div>
                  <div class="d-flex flex-column overflow-hidden">
                    <span class="fw-bold text-dark text-xs d-flex align-items-center gap-1">
                      {{ group.name }}
                      <i v-if="!group.is_public" class='bx bxs-lock-alt text-primary ms-1' title="Private"></i>
                    </span>
                  </div>
                </div>

                <div v-if="String(group.created_by.id) === String(user_id)" class="dropdown ms">
                  <a href="#" class="text-secondary p-1 d-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bx bx-dots-vertical-rounded fs-5 text-dark"></i>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 mt-2 py- rounded-3">
                    <li>
                      <a class="dropdown-item text-xs py-2 d-flex align-items-center gap-2" href="#"
                         data-bs-toggle="modal" data-bs-target="#create_group_modal" @click="openEditGroupModal(group)">
                        <i class="bi bi-pencil fs-6 text-primary"></i>
                        <span class="fw-500">Edit</span>
                      </a>
                    </li>
                    <li>
                      <hr class="dropdown-divider my-1">
                    </li>
                    <li>
                      <a class="dropdown-item text-xs py-2 d-flex align-items-center gap-2 text-danger" href="#" 
                         @click.prevent="deleteGroup(group.id)">
                        <i class="bi bi-trash fs-6"></i> 
                        <span class="fw-500">Delete</span>
                      </a>
                    </li>
                  </ul>
                </div>

              </div>
            </td>
          </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="d-none d-xl-block" v-if="!isHomePage">
  <div class="card bg-transparent border rounded shadow-sm mt-2">
    
    <div class="card-header bg-transparent d-flex justify-content-between align-items-center border-bottom py-3">
      <h6 class="mb-0 f text-dark d-flex align-items-center gap-2">
        {{ school_domain ? 'Classes' : 'Groups' }}
      </h6>
      <button 
        class="btn btn-sm btn-primary fab d-flex justify-content-center align-items-center shadow-sm" 
        data-bs-toggle="modal" 
        data-bs-target="#create_group_modal" 
        @click="editing=false"
        title="Create New"
        v-if="(school_domain && user_details.user_role === 'admin') || !school_domain"
      >
        <i class="bx bx-plus fw-bold"></i>
      </button>
    </div>

    <div class="card-body p-2">
      <table v-if="groups.length" class="table table-hover mb-0">
        <tbody>
          <tr v-for="group in groups" :key="group.id" class="border-0">
            <td class="border-0 align-middle px-2 py-2">
              
              <div class="d-flex justify-content-between align-items-center w-100">
                
                <div class="cursor-pointer d-flex align-items-center flex-grow-1 overflow-hidden" @click="open_group(group)">
                  
                  <div class="portal-avatar bg-yellow d-flex justify-content-center align-items-center shadow-sm me-3">
                    <i :class="school_domain ? 'bx bxs-graduation fs-5 text-change' : 'bx bxs-group fs-5 text-change'"></i>
                  </div>
                  
                  <div class="d-flex flex-column overflow-hidden">
                    <span class="fw-bold text-dark text-xs d-flex align-items-center gap-1">
                      {{ group.name }}
                      <i v-if="!group.is_public" class='bx bxs-lock-alt text-primary ms-1' title="Private"></i>
                    </span>
                  </div>

                </div>

                <div v-if="String(group.created_by.id) === String(user_id)" class="dropdown ms-2">
                  <a href="#" class="text-secondary p-1 d-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bx bx-dots-vertical-rounded fs-5 text-dark"></i>
                  </a>
                  
                  <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 mt-2 py-2 rounded-3">
                    <li>
                      <a class="dropdown-item text-xs py-2 d-flex align-items-center gap-2" href="#" 
                         data-bs-toggle="modal" data-bs-target="#create_group_modal" @click="openEditGroupModal(group)">
                        <i class="bi bi-pencil fs-6 text-primary"></i> 
                        <span class="fw-500">Edit</span>
                      </a>
                    </li>
                    <li>
                      <hr class="dropdown-divider my-1">
                    </li>
                    <li>
                      <a class="dropdown-item text-xs py-2 d-flex align-items-center gap-2 text-danger" href="#" 
                         @click.prevent="deleteGroup(group.id)">
                        <i class="bi bi-trash fs-6"></i> 
                        <span class="fw-500">Delete</span>
                      </a>
                    </li>
                  </ul>
                </div>

              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-else class="text-center py-4">
        <p class="text-secondary text-xs mb-0">
          No {{ school_domain ? 'Classes' : 'Groups' }} Available
        </p>
      </div>

    </div>
  </div>
</div>
<teleport to="body">
  <div class="modal fade" id="create_group_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xs test fw-500" id="exampleModalLabel">
            {{ editing 
               ? (school_domain ? 'Edit Class' : 'Edit Group') 
               : (school_domain ? 'Add a Class' : 'Create a Group') 
            }}
          </p>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <form @submit.prevent="handleSubmit">
          <div class="modal-body">
            <div class="mb-3">
              <label for="group_name" class="form-label text-xs fw-500">
                {{ school_domain ? 'Class Name' : 'Group Name' }} 
                <span class="text-danger">*</span>
              </label>
              <input 
                type="text" 
                class="form-control rounded text-xs" 
                id="group_name" 
                v-model="group_name"
                :placeholder="school_domain ? 'Enter class name ( 12 B )' : 'Enter group name'"
              >
              <p v-if="errors.group_name" class="text-danger text-xs">{{ errors.group_name }}</p>
            </div>

            <div class="mb-3">
              <label for="group_description" class="form-label text-xs fw-500">
                {{ school_domain ? 'Class Description' : 'Group Description' }}
              </label>
              <textarea 
                class="form-control rounded text-xs" 
                id="group_description" 
                v-model="group_description"
                :placeholder="school_domain ? 'Enter class details' : 'Enter group description'"
              ></textarea>
            </div>

            <div class="mb-3">
              <label for="is_public" class="form-label text-xs fw-500">Visibility <span class="text-danger">*</span></label>
              <select class="form-select rounded text-xs" id="is_public" v-model="is_public" required>
                <option selected hidden>Select visibility type</option>
                <option value="true">Public</option>
                <option value="false">Private</option>
              </select>
            </div>
          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded">
              {{ editing ? 'Update' : 'Submit' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>